<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="CHAPTER 2">
<header>
<p class="h2ch" id="ch2"><span class="right_1" epub:type="pagebreak" id="page_17" title="17"><span class="bg"><a href="#/text/nav#rch2">CHAPTER 2</a></span></span></p>
</header>
<p class="noindent"><span class="drop-cap"><b>E</b></span><b>RNST KOEHLER TRIED</b> punching some life into the pillow for what seemed the thousandth time that night, then rested his head on it once more.</p>
<p class="indent">In the distance Big Ben started to chime.</p>
<p class="indent">Six. He was an hour early.</p>
<p class="indent">He grunted, rolled out of bed, and picked up his dressing gown before crossing to the window.</p>
<p class="indent">He flexed his toes as he pulled back the heavy curtain an inch and looked out.</p>
<p class="indent">No snow: the forecast was wrong again.</p>
<p class="indent">He put on his dressing gown.</p>
<p class="indent">“Ernst?”</p>
<p class="indent">Koehler smiled, crossed back to the bed, and bent to kiss Lotte, his wife, softly on the forehead.</p>
<p class="indent">“Go back to sleep, it’s early,” he whispered.</p>
<p class="indent">“Come back to bed.” Lotte didn’t open her eyes. Just half her face was visible above the blankets, the rest hidden under her thick blond hair.</p>
<p class="indent">“I might as well do some work, now that I’m awake,” Koehler whispered as he brushed her forehead with his lips.</p>
<p class="indent"><span class="right_1" epub:type="pagebreak" id="page_18" title="18">Before he could rise, Lotte reached with her arm and pulled him close. They kissed before she set him free, her arm snaking back under the blankets.</span></p>
<p class="indent">“I love you, Ernst Koehler.” Lotte’s voice was thick with sleep.</p>
<p class="indent">“I love you, Lotte Koehler,” Koehler replied as he pulled the blankets up further around her.</p>
<p class="indent">“I’m so happy, together again,” Lotte said, drifting off to sleep.</p>
<p class="indent">Koehler smiled, traced a fingertip across Lotte’s cheek, and left the bedroom, carefully closing the door behind him. He padded through the plush living room of his apartment and into the small kitchen, where he lit the stove and filled a kettle.</p>
<p class="indent">A small, sleepy-eyed black kitten appeared at the door. It yawned, flicked its head, then padded across until it was weaving around his legs, like long grass in a breeze.</p>
<p class="indent">Koehler felt the brush of the kitten’s tail and looked down. He smiled at the get-well-soon gift from Anja, his daughter. She had christened the kitten “Schwarz,” and Koehler had a feeling that when it was time for his wife and daughter to go back to Berlin, little Schwarz would be going with them.</p>
<p class="indent">Koehler hoped he would be going, too.</p>
<p class="indent">“We’ve got a big day ahead of us, little Schwarzy. Today we find out if I’m ever going to leave this shithole, England.”</p>
<p class="indent">Schwarz purred even louder.</p>
<p class="indent">“Maybe we’ll get a house with a garden for you?”</p>
<p class="indent">Schwarz sat down, staring at Koehler.</p>
<p class="indent">“Or would you sooner leave me here, and go back to Germany with just Lotte and Anja?”</p>
<p class="indent">Schwarz meowed and Koehler smiled, as the kettle started to boil.</p>
<p class="indent">“Yeah, sure. You just want your breakfast.”</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062394613_Chapter_2.vue?3bc1a7aa